module.exports = __webpack_public_path__ + "img/QRcode.a2585368.png";